const orderTranslation = {
  frequentlyAskedQuestionsText1: "Frequently Asked Questions",
  frequentlyAskedQuestionsText2: "I'm having an issue with order delivery...",
  frequentlyAskedQuestionsText3: "Please contact Bidscape to receive assistance.",
  frequentlyAskedQuestionsText4: `Some of the items on the order that I guaranteed are no longer in inventory..`,
  frequentlyAskedQuestionsText5: `Please contact Bidscape as soon as possible to make us aware of any items that will be missing from the order.`,
  frequentlyAskedQuestionsText6: `The customer is declining an item because of quality or due to an error...`,
  frequentlyAskedQuestionsText7: `In the case of an error, please either organize an exchange for the correct product or notify Bidscape to issue refunds.`,
  frequentlyAskedQuestionsText8: `The customer is contacting me AFTER delivery has already taken place to request a return or exchange of an item or items?`,
  frequentlyAskedQuestionsText9: `Bidscape does not allow returns or exchanges after delivery has already taken place.`,

  orderText1: "Delivery Date:",
  orderText2: "TBD (phased delivery)",
  orderText3: "Pickup Date:",
  orderText4: "Destination:",
  orderText5: "For payment, please contact",
  orderText6: "***Please do not give a receipt or pricing to the customer. Drop ticket only.***",
  orderText7: "Order Items",
  orderText8: "each",
  orderText9: "Subtotal:",
  orderText10: "Delivery Charge:",
  orderText11: "Total:",
  orderText12: "Back",
  orderText13: "Photo",
  orderText14: "Order Notes:",

  orderQueryErrorText1: `An error occurred while loading your order, please make sure you have an internet connection, or else contact Heather at`,
  orderQueryErrorText2: `An error occurred while loading your order, contact Heather at`,
  orderQueryErrorText3: `for assistance.`,
  orderQueryErrorText4: `Back`,
  orderQueryErrorText5: `Try again`,

  // Order Confirmation
  orderConfirmationText1: "Error Loading Order",
  orderConfirmationText2: "Failed to load order confirmation data",
  orderConfirmationText3: "Go to Dashboard",
  orderConfirmationText4: "Review Items",
  orderConfirmationText5: "Order Summary",
  orderConfirmationText6: "All items marked as out of stock",
  orderConfirmationText7: "each",
  orderConfirmationText8: "Qty:",
  orderConfirmationText9: "Subtotal",
  orderConfirmationText10: "Submitting Order...",
  orderConfirmationText11: "Confirm Order",
  orderConfirmationText12: "Complete delivery terms to submit",
  orderConfirmationText13: "Review All Items",
  orderConfirmationText14: "Please review and confirm or change all items before proceeding with the order.",
  orderConfirmationText15: "Size:",
  orderConfirmationText16: "Latin Name:",
  orderConfirmationText17: "Common Name:",
  orderConfirmationText18: "Quantity:",
  orderConfirmationText19: "Out of stock",
  orderConfirmationText20: "Price changed",
  orderConfirmationText21: "Close",
  orderConfirmationText22: "Current Price:",
  orderConfirmationText23: "What's the new price?",
  orderConfirmationText24: "Cancel",
  orderConfirmationText25: "Confirm Price",
  orderConfirmationText26: "Confirmed",
  orderConfirmationText27: "Unconfirmed",
  orderConfirmationText28: "Out of Stock",
  orderConfirmationText29: "Price Changed",
  orderConfirmationText30: "Changed",
  orderConfirmationText31: "Unknown",
  orderConfirmationText32: "Oh no!",

  orderConfirmationHeaderText1: "Please review the below pending order. Once you provide confirmation of availability, a purchase order will follow. Questions? Contact",
  orderConfirmationText33: "Notes:",

  // Order Confirmation Notifications
  orderConfirmationSuccessTitle: "Order Confirmed!",
  orderConfirmationSuccessMessage: "Your order confirmation has been submitted successfully",
  orderConfirmationErrorTitle: "Error",
  orderConfirmationErrorMessage: "An error occurred while confirming your order",
};

export default orderTranslation;
